import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  BestFareOptionsMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  OneWayRoutePickerMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';

import { ModifyBookWidgetBaseComponent } from '../modify-book-widget-base/modify-book-widget-base.component';
@Component({
  selector: 'idp-modify-book-widget-desktop-ow-rt',
  standalone: true,
  imports: [
    CommonModule,
    DatePickerMachCoreComponent,
    SelectMachCoreComponent,
    OneWayRoutePickerMachCoreComponent,
    BestFareOptionsMachCoreComponent,
    MeetingCodeMachCoreComponent,
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modify-book-widget-desktop-ow-rt.component.html',
  styleUrls: ['./modify-book-widget-desktop-ow-rt.component.scss']
})
export class ModifyBookWidgetOwRtDesktopComponent extends ModifyBookWidgetBaseComponent {}
